import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import Signup from "./Signup";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col
} from "reactstrap";
import Header from "../Header/Header";
import { TableHeader, Pagination, Search } from "../../DataTable"
import useFullPageLoader from "../../hooks/useFullPageLoader"
import Baja from "../../views/Baja";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ListadoUsuarios() {
  const { user } = useContext(AuthContext);
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const URL_LISTA_USERS = process.env.REACT_APP_URL_LISTA_USERS;
  const [usuarios, setUsuarios] = useState([]);

  //--- Pagination
const [comments, setComments] = useState([]);
const [loader, showLoader, hideLoader] = useFullPageLoader();
const [totalItems, setTotalItems] = useState(0);
const [currentPage, setCurrentPage] = useState(1);
const [search, setSearch] = useState("");
const [sorting, setSorting] = useState({ field: "", order: "" });
const [activo, setActivo] = useState("");
const ITEMS_PER_PAGE = 50

const URL_PLANTELES = process.env.REACT_APP_URL_PLANTELES;
const URL_AREAS = process.env.REACT_APP_URL_AREAS;
const [idEdit, setIdEdit] = useState();
const [nombre, setNombre] = useState();
const [apellido, setApellido] = useState();
const [email, setEmail] = useState();
const [is_active, setIsActive] = useState();
const [planteles, setPlanteles] = useState([]);
const [plantel, setPlantel] = useState();
const [areas, setAreas] = useState([]);
const [area, setArea] = useState();

const [idPermisos, setIdPermisos] = useState();

// ===== PERMISOS GRANULARES POR BOTON (2026-06) =====
// Un solo objeto en lugar de 249 useState. Inicializado en Permisos() desde el user.
const GRAN_PERMS_SECTIONS = [
  { title: "INVENTARIOS TELAS", perms: [["ivt_pdf","PDF"],["ivt_email","Email"],["ivt_excel","Excel"],["ivt_editar","Editar"],["ivt_cortarRollo","Cortar Rollo"],["ivt_qr","QR"]] },
  { title: "INVENTARIOS", perms: [["inv_pdf","PDF"],["inv_email","Email"],["inv_excel","Excel"],["inv_ajuste","Ajuste"]] },
  { title: "SEGUIMIENTO TELAS", perms: [["seg_pdf","PDF"],["seg_email","Email"],["seg_excel","Excel"]] },
  { title: "INV HABILITACION", perms: [["ivh_pdf","PDF"],["ivh_email","Email"],["ivh_excel","Excel"],["ivh_salida","Salida"]] },
  { title: "ARTICULOS", perms: [["art_pdf","PDF"],["art_email","Email"],["art_excel","Excel"],["art_editar","Editar"],["art_baja","Baja"],["art_ficha","Ficha Tec."]] },
  { title: "CLIENTES", perms: [["cli_pdf","PDF"],["cli_email","Email"],["cli_excel","Excel"],["cli_editar","Editar"],["cli_baja","Baja"],["cli_sucursales","Sucursales"],["cli_areas","Areas"],["cli_cuentas","Cuentas"]] },
  { title: "PROVEEDORES", perms: [["prv_pdf","PDF"],["prv_email","Email"],["prv_excel","Excel"],["prv_editar","Editar"],["prv_baja","Baja"]] },
  { title: "MAQUILEROS", perms: [["maq_pdf","PDF"],["maq_email","Email"],["maq_excel","Excel"],["maq_editar","Editar"],["maq_baja","Baja"]] },
  { title: "COMPRAS", perms: [["cmp_pdf","PDF"],["cmp_email","Email"],["cmp_excel","Excel"],["cmp_editar","Editar"],["cmp_cancelar","Cancelar"]] },
  { title: "ORDENES COMPRA", perms: [["oc_pdf","PDF"],["oc_email","Email"],["oc_excel","Excel"],["oc_editar","Editar"],["oc_autorizar","Autorizar"],["oc_baja","Baja"]] },
  // { title: "COMPRAS DIRECTAS", perms: [["cmd_pdf","PDF"],["cmd_email","Email"],["cmd_excel","Excel"],["cmd_editar","Editar"]] },
  // { title: "OC DIRECTAS", perms: [["ocd_pdf","PDF"],["ocd_email","Email"],["ocd_excel","Excel"],["ocd_editar","Editar"]] },
  { title: "DEV PROVEEDORES", perms: [["dpv_pdf","PDF"],["dpv_email","Email"],["dpv_excel","Excel"],["dpv_editar","Editar"],["dpv_baja","Baja"]] },
  { title: "CORTES", perms: [["crt_pdf","PDF"],["crt_email","Email"],["crt_excel","Excel"],["crt_editar","Editar"],["crt_cancelar","Cancelar Corte"],["crt_observaciones","Observaciones"],["crt_salidaProc","Salida Proceso"],["crt_entradaProc","Entrada Proceso"],["crt_entradaAlm","Entrada Almacen"],["crt_habilitacion","Habilitacion"],["crt_cancelarSal","Cancelar Salida"]] },
  { title: "ORDENES CORTE", perms: [["ocp_pdf","PDF"],["ocp_email","Email"],["ocp_excel","Excel"],["ocp_editar","Editar"],["ocp_baja","Baja"],["ocp_observaciones","Observaciones"],["ocp_recibir","Recibir"],["ocp_cortar","Cortar"],["ocp_autMolde","Aut. Molde"],["ocp_autorizar","Autorizar Orden"],["ocp_pdfNumInt","PDF Num. Interno"]] },
  { title: "ORDENES CORTE EXTERNO", perms: [["ocx_pdf","PDF"],["ocx_email","Email"],["ocx_excel","Excel"],["ocx_editar","Editar"],["ocx_baja","Baja"],["ocx_observaciones","Observaciones"],["ocx_recibir","Recibir"],["ocx_cortar","Cortar"],["ocx_habilitacion","Habilitacion"]] },
  // { title: "APARTADOS", perms: [["apt_pdf","PDF"],["apt_email","Email"],["apt_excel","Excel"],["apt_editar","Editar"],["apt_baja","Baja"]] },
  { title: "PEDIDOS", perms: [["ped_pdf","PDF"],["ped_email","Email"],["ped_excel","Excel"],["ped_editar","Editar"],["ped_cancelar","Cancelar"],["ped_observaciones","Observaciones"],["ped_consumoTelas","Consumo Telas"],["ped_consumoCambiarTela","Consumo: cambiar tela del pedido"]] },
  { title: "COTIZACIONES", perms: [["cot_pdf","PDF"],["cot_email","Email"],["cot_excel","Excel"],["cot_editar","Editar"],["cot_baja","Baja"],["cot_editArt","Editar Articulos"]] },
  { title: "SURTIDOS", perms: [["sur_pdf","PDF"],["sur_email","Email"],["sur_excel","Excel"],["sur_editar","Editar"],["sur_baja","Baja"]] },
  { title: "DEVOLUCIONES CLI", perms: [["dev_pdf","PDF"],["dev_email","Email"],["dev_excel","Excel"],["dev_editar","Editar"],["dev_baja","Baja"]] },
  // { title: "PEDIDOS TELAS", perms: [["pdt_pdf","PDF"],["pdt_email","Email"],["pdt_excel","Excel"],["pdt_editar","Editar"],["pdt_baja","Baja"]] },
  // { title: "SURTIDOS TELAS", perms: [["srt_pdf","PDF"],["srt_email","Email"],["srt_excel","Excel"],["srt_editar","Editar"],["srt_baja","Baja"]] },
  // { title: "DEV TELAS", perms: [["dvt_pdf","PDF"],["dvt_email","Email"],["dvt_excel","Excel"],["dvt_editar","Editar"],["dvt_baja","Baja"]] },
  // { title: "APARTADOS TELAS", perms: [["apt2_pdf","PDF"],["apt2_email","Email"],["apt2_excel","Excel"],["apt2_editar","Editar"],["apt2_baja","Baja"]] },
  { title: "FACTURAS", perms: [["fac_pdf","PDF"],["fac_email","Email"],["fac_excel","Excel"],["fac_editar","Editar"],["fac_cancelar","Cancelar"],["fac_timbrar","Timbrar"]] },
  { title: "COMP. PAGO", perms: [["cpg_pdf","PDF"],["cpg_email","Email"],["cpg_excel","Excel"],["cpg_editar","Editar"],["cpg_baja","Baja"]] },
  { title: "NOTAS CREDITO", perms: [["ncr_pdf","PDF"],["ncr_email","Email"],["ncr_excel","Excel"],["ncr_editar","Editar"],["ncr_baja","Baja"]] },
  { title: "DEV FISCAL", perms: [["dvf_pdf","PDF"],["dvf_email","Email"],["dvf_excel","Excel"],["dvf_editar","Editar"],["dvf_baja","Baja"]] },
  { title: "ABONOS PROV", perms: [["abp_pdf","PDF"],["abp_email","Email"],["abp_excel","Excel"],["abp_editar","Editar"],["abp_baja","Baja"]] },
  { title: "ABONOS MAQ", perms: [["abm_pdf","PDF"],["abm_email","Email"],["abm_excel","Excel"],["abm_editar","Editar"],["abm_baja","Baja"]] },
  { title: "ANTICIPOS PROV", perms: [["ant_pdf","PDF"],["ant_email","Email"],["ant_excel","Excel"],["ant_editar","Editar"],["ant_baja","Baja"]] },
  { title: "NOTAS CxP", perms: [["ncp_pdf","PDF"],["ncp_email","Email"],["ncp_excel","Excel"],["ncp_editar","Editar"],["ncp_baja","Baja"]] },
  { title: "DOCUMENTACION", perms: [["doc_pdf","PDF"],["doc_email","Email"],["doc_excel","Excel"],["doc_editar","Editar"],["doc_baja","Baja"]] },
  { title: "ABONOS CxC", perms: [["abo_pdf","PDF"],["abo_email","Email"],["abo_excel","Excel"],["abo_editar","Editar"],["abo_baja","Baja"]] },
  { title: "ABONOS FACTURAS", perms: [["abf_pdf","PDF"],["abf_email","Email"],["abf_excel","Excel"],["abf_editar","Editar"],["abf_baja","Baja"]] },
  { title: "VENTAS ADMIN", perms: [["vad_pdf","PDF"],["vad_email","Email"],["vad_excel","Excel"],["vad_editar","Editar"],["vad_cancelar","Cancelar"]] },
  { title: "NOTAS CARGO", perms: [["nca_pdf","PDF"],["nca_email","Email"],["nca_excel","Excel"],["nca_editar","Editar"],["nca_baja","Baja"]] },
  { title: "DEV ADMIN", perms: [["dva_pdf","PDF"],["dva_email","Email"],["dva_excel","Excel"],["dva_editar","Editar"],["dva_baja","Baja"]] },
  // { title: "RETIROS", perms: [["ret_pdf","PDF"],["ret_email","Email"],["ret_excel","Excel"],["ret_editar","Editar"],["ret_baja","Baja"]] },
  { title: "COMPRA VENTA", perms: [["cvt_pdf","PDF"],["cvt_email","Email"],["cvt_excel","Excel"],["cvt_editar","Editar"],["cvt_baja","Baja"]] },
  { title: "POR RETIRAR", perms: [["prt_pdf","PDF"],["prt_email","Email"],["prt_excel","Excel"],["prt_editar","Editar"],["prt_baja","Baja"]] },
  { title: "COLABORADORES", perms: [["clb_pdf","PDF"],["clb_email","Email"],["clb_excel","Excel"],["clb_editar","Editar"],["clb_baja","Baja"]] },
  { title: "TRASPASOS ENTRADA", perms: [["tse_pdf","PDF"],["tse_email","Email"],["tse_excel","Excel"],["tse_editar","Editar"]] },
  { title: "TRASPASOS SALIDA", perms: [["tss_pdf","PDF"],["tss_email","Email"],["tss_excel","Excel"],["tss_editar","Editar"]] },
  { title: "AJUSTE", perms: [["aju_pdf","PDF"],["aju_email","Email"],["aju_excel","Excel"],["aju_editar","Editar"]] },
  { title: "LOGS", perms: [["log_pdf","PDF"],["log_email","Email"],["log_excel","Excel"]] },
];
// ===== PERMISOS LEGACY (menus + create + flags) – misma estructura =====
const LEGACY_PERMS_SECTIONS = [
  { title: "MENÚS GENERALES", perms: [
    // Orden del top-bar real del sistema
    ["menu_catalogos","1. Menu Catálogos"],
    ["menu_articulos","   Menu Artículos"],
    ["menu_clientes","   Menu Clientes"],
    ["menu_proveedores","   Menu Proveedores"],
    ["menu_compras","2. Menu Compras"],
    ["menu_produccion","3. Menu Producción"],
    ["menu_admin","4. Menu Admin / CXC"],
    ["menu_adminCxP","5. Menu Admin CxP"],
    // (2026-10) módulo sencillo de Pagos y Saldos (usuario especial de CxP)
    ["menu_cxpPagos","   Pagos y Saldos CxP"],
    ["menu_gastos","6. Menu Gastos"],
    // (menu_empleados, menu_puestos, menu_usuarios, menu_logs viven en sus secciones específicas)
    ["menu_reportes","7. Menu Reportes"],
    // Otros menus secundarios
    ["menu_empresas","Menu Empresas"],
    ["menu_planteles","Menu Planteles"],
    ["menu_areas","Menu Areas"],
    ["menu_ciclos","Menu Ciclos"],
    ["menu_periodos_admin","Menu Periodos Admin"],
    ["menu_departamentos","Menu Departamentos"],
    ["menu_cobradores","Menu Cobradores"],
    ["menu_edoCta_Cliente","Menu Edo Cta Cliente"],
    ["menuSocios","Menu Socios"],
  ]},
  // (2026-10) CRM (portado de EnvasesBH)
  { title: "CRM", perms: [
    ["menu_crm","Menú Acceso"],
    ["crm_prospectos_create","Crear / Editar Prospectos"],
    ["crm_oportunidades_create","Mover Oportunidades"],
    ["crm_config","Configuración (Etapas)"],
  ] },
  { title: "CAT. COLORES",       perms: [["menu_colores","Menu"],["colores_create","Crear"]] },
  { title: "CAT. TIPOS DE TELA", perms: [["menu_tipos_telas","Menu"],["tipos_telas_create","Crear"]] },
  { title: "CAT. TELAS",         perms: [["menu_telas","Menu"],["telas_create","Crear"]] },
  { title: "CAT. HABILITACION",  perms: [["menu_habilitacion","Menu"],["habilitacion_create","Crear"]] },
  { title: "CAT. ARTICULOS",     perms: [["articulos_create","Crear"],["eliminar_fichas","Eliminar Fichas"]] },
  { title: "CAT. CLIENTES",      perms: [["clientes_create","Crear"],["clientes_edo_cta","Edo Cta"]] },
  { title: "CAT. PROVEEDORES",   perms: [["proveedores_create","Crear"]] },
  { title: "INV. TELAS (Menus)", perms: [
    ["menu_inventariosTelas","Menu Inv Telas"],
    ["inventariosTelas","Inv Telas"],
    ["menu_disponibleTelas","Menu Disponible"],
    ["disponible_vendedores","Disp Vendedores"],
  ]},
  { title: "INV. GENERAL (Menus)", perms: [
    ["menu_inventarios","Menu"],["inventarios","Inventarios"],
  ]},
  { title: "TRASPASOS SALIDA (Menu)",  perms: [["menu_traspasos_salida","Menu"],["traspasos_salida_create","Crear"]] },
  { title: "TRASPASOS ENTRADA (Menu)", perms: [["menu_traspasos_entrada","Menu"],["traspasos_entrada_create","Crear"]] },
  { title: "COMPRAS (Menus)", perms: [
    ["menu_compras","Menu Compras"],
    ["compras","Compras"],
    ["compras_create","Crear"],
    ["cancelar_compra","Cancelar"],
  ]},
  { title: "ORDENES COMPRA (Menus)", perms: [
    ["menu_oc","Menu OC"],
    ["oc_create","Crear"],
    ["oc_autorizacion","Autorizar"],
  ]},
  { title: "DEV PROVEEDORES (Menus)", perms: [
    ["menu_devolucionesProveedores","Menu"],
    ["devolucionesProveedores_create","Crear"],
  ]},
  { title: "VENTAS (Menus)",      perms: [["menu_ventas","Menu Ventas"],["ventas_create","Crear"]] },
  { title: "PEDIDOS (Menus)",     perms: [["menu_pedidos","Menu Pedidos"],["pedidos_create","Crear"]] },
  { title: "SURTIDOS (Menus)",    perms: [["menu_surtidos","Menu Surtidos"],["surtidos_create","Crear"]] },
  { title: "DEVOLUCIONES CLI (Menus)", perms: [["menu_devoluciones","Menu"],["devoluciones_create","Crear"]] },
  { title: "FISCAL (Sub-menús)", perms: [
    ["facturasFiscal","Facturas Fiscal"],
    ["compPagosFiscal","Comp Pagos"],
    ["devolucionesFiscal","Dev Fiscal"],
    ["notasCreditoFiscal","Notas Crédito"],
  ]},
  { title: "FACTURAS CxC", perms: [
    ["facturas_edo_cta","Edo Cta"],
    ["facturas_cargos","Cargos"],
    ["facturas_cargos_create","Crear Cargo"],
    ["facturas_abonos","Abonos"],
    ["facturas_abonos_create","Crear Abono"],
    ["facturas_abonos_edit","Editar Abono"],
  ]},
  { title: "GASTOS",        perms: [["gastos_create","Crear"],["gastos_autorizar","Autorizar"]] },
  { title: "EMPLEADOS",     perms: [["menu_empleados","Menu"],["empleados_create","Crear"],["empleados_sueldo","Sueldo"]] },
  { title: "PUESTOS",       perms: [["menu_puestos","Menu"],["puestos_create","Crear"]] },
  { title: "USUARIOS",      perms: [["menu_usuarios","Menu"],["usuarios_create","Crear"],["usuarios_permisos","Permisos"]] },
];

// Unificado: todas las secciones (legacy + nuevas) en una sola lista
const ALL_PERMS_SECTIONS = [...LEGACY_PERMS_SECTIONS, ...GRAN_PERMS_SECTIONS];
const GRAN_PERMS_ALL = GRAN_PERMS_SECTIONS.flatMap(s => s.perms.map(([k]) => k));
const LEGACY_PERMS_ALL = LEGACY_PERMS_SECTIONS.flatMap(s => s.perms.map(([k]) => k));
const ALL_PERMS_ALL = [...LEGACY_PERMS_ALL, ...GRAN_PERMS_ALL];

const emptyGranPerms = () => GRAN_PERMS_ALL.reduce((acc, k) => ({ ...acc, [k]: false }), {});
const emptyLegacyPerms = () => LEGACY_PERMS_ALL.reduce((acc, k) => ({ ...acc, [k]: false }), {});
const [granPerms, setGranPerms] = useState(emptyGranPerms());
const [legacyPerms, setLegacyPerms] = useState(emptyLegacyPerms());

// Routers: leen/escriben del objeto correcto según el key
const isLegacyKey = (k) => LEGACY_PERMS_ALL.includes(k);
const getPerm = (k) => isLegacyKey(k) ? !!legacyPerms[k] : !!granPerms[k];
const setPerm = (k, v) => {
  if (isLegacyKey(k)) setLegacyPerms(prev => ({ ...prev, [k]: !!v }));
  else setGranPerms(prev => ({ ...prev, [k]: !!v }));
};
const setGranPerm = (k, v) => setPerm(k, v); // backwards-compat

// Macro-grupos ORDENADOS por el menú TOP-BAR real (Header.js):
// Catálogos → Ventas → Compras → Producción → Inventarios → Admin/CXC → Retiros → CXP → Gastos → Nóminas → Usuarios → Logs.
// Las secciones de abajo usan MERGED_SECTIONS (legacy + botones granulares juntos por módulo).
const MACRO_GROUPS = [
  { label: "0. CRM",                color: "#8b5cf6", sections: ["CRM"] },
  { label: "1. CATÁLOGOS",          color: "#6c757d", sections: [
    "COLORES","TIPOS DE TELA","TELAS (Catálogo)","HABILITACIÓN (Catálogo)",
    "ARTÍCULOS","CLIENTES","PROVEEDORES","MAQUILEROS",
  ]},
  { label: "2. VENTAS",             color: "#198754", sections: [
    "VENTAS (Menú)","PEDIDOS","COTIZACIONES","SURTIDOS","DEVOLUCIONES CLIENTES",
    // "APARTADOS",
    // "PEDIDOS TELAS","SURTIDOS TELAS","DEV TELAS","APARTADOS TELAS",
  ]},
  { label: "3. COMPRAS",            color: "#d63384", sections: [
    "COMPRAS","ÓRDENES DE COMPRA","COMPRAS DIRECTAS","OC DIRECTAS","DEV PROVEEDORES",
  ]},
  { label: "4. PRODUCCIÓN",         color: "#fd7e14", sections: [
    "PRODUCCIÓN (Menú)","CORTES","ÓRDENES DE CORTE","ÓRDENES DE COMPRA (Producción)",
  ]},
  { label: "5. MUESTRAS",           color: "#20c997", sections: [
    "MUESTRAS",
  ]},
  { label: "6. INVENTARIOS",        color: "#0d6efd", sections: [
    "INVENTARIOS TELAS","INVENTARIOS GENERAL","SEGUIMIENTO TELAS","INV. HABILITACIÓN",
    "TRASPASOS SALIDA","TRASPASOS ENTRADA","AJUSTE",
  ]},
  { label: "6. ADMIN / CXC",        color: "#0dcaf0", sections: [
    "ADMIN (Menú)","ABONOS CXC","VENTAS ADMIN","NOTAS CARGO","DEV ADMIN",
  ]},
  // { label: "RETIROS",               color: "#ffc107", sections: [
  //   "RETIROS","COMPRA VENTA","POR RETIRAR",
  // ]},
  { label: "7. CXP",                color: "#6f42c1", sections: [
    "CXP (Menú)","ABONOS PROVEEDORES","ABONOS MAQUILEROS","ANTICIPOS PROVEEDORES","NOTAS CXP"
    // ,"DOCUMENTACIÓN",
  ]},
  { label: "8. GASTOS",             color: "#dc3545", sections: [
    "GASTOS (Menú)","GASTOS (Permisos)"
    // ,"PRESUPUESTOS","INGRESOS / EGRESOS",
  ]},
  { label: "9. COLABORADORES", color: "#495057", sections: [
    "NÓMINAS (Menú)","EMPLEADOS","COLABORADORES","PUESTOS"
    // ,"NÓMINAS (Datos)",
  ]},
  { label: "10. USUARIOS",          color: "#20c997", sections: ["USUARIOS"] },
  { label: "11. LOGS",              color: "#6610f2", sections: ["LOGS"] },
  { label: "OTROS MENÚS",           color: "#6c757d", sections: ["OTROS MENÚS"] },
];
// ===== Ocultar todo lo relacionado a Fiscal / Facturas (2026-06) =====
// Si más adelante quieres mostrarlos, vacía estos sets.
const HIDDEN_MACRO_LABELS = new Set([
  "FISCAL (Sub-menús)",
  "[BOTONES] FISCAL",
]);
const HIDDEN_SECTION_TITLES = new Set([
  "FACTURAS CxC",
  "ABONOS FACTURAS",
]);
const HIDDEN_PERM_KEYS = new Set([
  "menu_fiscal",
  "menu_facturas",
]);
const isMacroVisible = (m) => !HIDDEN_MACRO_LABELS.has(m.label);
const isSectionVisible = (title) => !HIDDEN_SECTION_TITLES.has(title);
const visiblePermsOf = (sec) => (sec?.perms || []).filter(([k]) => !HIDDEN_PERM_KEYS.has(k));

// ===== MERGED_SECTIONS: legacy + nuevos botones JUNTOS por módulo (2026-06) =====
// Cada sección contiene primero el menú/acceso (legacy), luego "crear" / acciones
// administrativas legacy, y al final los botones granulares en orden visual real
// (PDF / Email / Excel del header del listado, luego per-fila Editar / Cancelar / Baja).
const MERGED_SECTIONS = [
  // ===== 0. CRM (2026-10) =====
  { title: "CRM", perms: [
    ["menu_crm","Menú Acceso"],
    ["crm_prospectos_create","Crear / Editar Prospectos"],
    ["crm_oportunidades_create","Mover Oportunidades"],
    ["crm_config","Configuración (Etapas)"],
  ] },
  // ===== 1. CATÁLOGOS =====
  { title: "COLORES",                 perms: [["menu_colores","Menú Acceso"],["colores_create","Crear"]] },
  { title: "TIPOS DE TELA",           perms: [["menu_tipos_telas","Menú Acceso"],["tipos_telas_create","Crear"]] },
  { title: "TELAS (Catálogo)",        perms: [["menu_telas","Menú Acceso"],["telas_create","Crear"]] },
  { title: "HABILITACIÓN (Catálogo)", perms: [["menu_habilitacion","Menú Acceso"],["habilitacion_create","Crear"]] },
  { title: "ARTÍCULOS", perms: [
    ["menu_articulos","Menú Acceso"],
    ["articulos_create","Crear"],
    ["eliminar_fichas","Eliminar Fichas Técnicas"],
    ["art_pdf","PDF"],
    ["art_email","eMail"],
    ["art_excel","Excel"],
    ["art_editar","Editar"],
    ["art_baja","Baja"],
    ["art_ficha","Subir Ficha Técnica"],
  ]},
  { title: "CLIENTES", perms: [
    ["menu_clientes","Menú Acceso"],
    ["clientes_create","Crear"],
    ["clientes_edo_cta","Estado de Cuenta"],
    ["cli_pdf","PDF"],
    ["cli_email","eMail"],
    ["cli_excel","Excel"],
    ["cli_editar","Editar"],
    ["cli_baja","Baja"],
    ["cli_sucursales","Sucursales"],
    ["cli_areas","Áreas"],
    ["cli_cuentas","Cuentas"],
  ]},
  { title: "PROVEEDORES", perms: [
    ["menu_proveedores","Menú Acceso"],
    ["proveedores_create","Crear"],
    ["prv_pdf","PDF"],
    ["prv_email","eMail"],
    ["prv_excel","Excel"],
    ["prv_editar","Editar"],
    ["prv_baja","Baja"],
  ]},
  { title: "MAQUILEROS", perms: [
    ["maq_pdf","PDF"],
    ["maq_email","eMail"],
    ["maq_excel","Excel"],
    ["maq_editar","Editar"],
    ["maq_baja","Baja"],
  ]},

  // ===== 2. VENTAS =====
  { title: "VENTAS (Menú)", perms: [["menu_ventas","Menú Acceso"],["ventas_create","Crear"]] },
  { title: "PEDIDOS", perms: [
    ["menu_pedidos","Menú Acceso"],
    ["pedidos_create","Crear"],
    ["ped_pdf","PDF"],
    ["ped_email","eMail"],
    ["ped_excel","Excel"],
    ["ped_editar","Editar"],
    ["ped_cancelar","Cancelar"],
    ["ped_observaciones","Observaciones"],
    ["ped_consumoTelas","Consumo Telas"],
    ["ped_consumoCambiarTela","Consumo: cambiar tela del pedido"],
  ]},
  { title: "COTIZACIONES", perms: [
    ["cot_pdf","PDF"],
    ["cot_email","eMail"],
    ["cot_excel","Excel"],
    ["cot_editar","Editar"],
    ["cot_baja","Baja"],
    ["cot_editArt","Editar Artículos"],
  ]},
  { title: "SURTIDOS", perms: [
    ["menu_surtidos","Menú Acceso"],
    ["surtidos_create","Crear"],
    ["sur_pdf","PDF"],
    ["sur_email","eMail"],
    ["sur_excel","Excel"],
    ["sur_editar","Editar"],
    ["sur_baja","Baja"],
  ]},
  { title: "DEVOLUCIONES CLIENTES", perms: [
    ["menu_devoluciones","Menú Acceso"],
    ["devoluciones_create","Crear"],
    ["dev_pdf","PDF"],
    ["dev_email","eMail"],
    ["dev_excel","Excel"],
    ["dev_editar","Editar"],
    ["dev_baja","Baja"],
  ]},
  // { title: "APARTADOS", perms: [
  //   ["apt_pdf","PDF"],
  //   ["apt_email","eMail"],
  //   ["apt_excel","Excel"],
  //   ["apt_editar","Editar"],
  //   ["apt_baja","Baja"],
  // ]},
  // { title: "PEDIDOS TELAS", perms: [
  //   ["pdt_pdf","PDF"],["pdt_email","eMail"],
  //   ["pdt_excel","Excel"],["pdt_editar","Editar"],["pdt_baja","Baja"],
  // ]},
  // { title: "SURTIDOS TELAS", perms: [
  //   ["srt_pdf","PDF"],["srt_email","eMail"],
  //   ["srt_excel","Excel"],["srt_editar","Editar"],["srt_baja","Baja"],
  // ]},
  // { title: "DEV TELAS", perms: [
  //   ["dvt_pdf","PDF"],["dvt_email","eMail"],
  //   ["dvt_excel","Excel"],["dvt_editar","Editar"],["dvt_baja","Baja"],
  // ]},
  // { title: "APARTADOS TELAS", perms: [
  //   ["apt2_pdf","PDF"],["apt2_email","eMail"],
  //   ["apt2_excel","Excel"],["apt2_editar","Editar"],["apt2_baja","Baja"],
  // ]},

  // ===== 3. COMPRAS =====
  { title: "COMPRAS", perms: [
    ["menu_compras","Menú Acceso"],
    ["compras","Ver Compras"],
    ["compras_create","Crear"],
    ["cancelar_compra","Cancelar Compra"],
    ["cmp_pdf","PDF"],
    ["cmp_email","eMail"],
    ["cmp_excel","Excel"],
    ["cmp_editar","Editar"],
    ["cmp_cancelar","Cancelar"],
  ]},
  { title: "ÓRDENES DE COMPRA", perms: [
    ["menu_oc","Menú Acceso"],
    ["oc_create","Crear"],
    ["oc_autorizacion","Autorizar Orden (legado global)"],
    ["oc_pdf","PDF"],
    ["oc_email","eMail"],
    ["oc_excel","Excel"],
    ["oc_editar","Editar"],
    ["oc_autorizar","Autorizar"],
    ["oc_baja","Baja"],
  ]},
  // { title: "COMPRAS DIRECTAS", perms: [
  //   ["cmd_pdf","PDF"],["cmd_email","eMail"],
  //   ["cmd_excel","Excel"],["cmd_editar","Editar"],
  // ]},
  // { title: "OC DIRECTAS", perms: [
  //   ["ocd_pdf","PDF"],["ocd_email","eMail"],
  //   ["ocd_excel","Excel"],["ocd_editar","Editar"],
  // ]},
  { title: "DEV PROVEEDORES", perms: [
    ["menu_devolucionesProveedores","Menú Acceso"],
    ["devolucionesProveedores_create","Crear"],
    ["dpv_pdf","PDF"],
    ["dpv_email","eMail"],
    ["dpv_excel","Excel"],
    ["dpv_editar","Editar"],
    ["dpv_baja","Baja"],
  ]},

  // ===== 4. PRODUCCIÓN =====
  { title: "PRODUCCIÓN (Menú)", perms: [["menu_produccion","Menú Acceso"]] },
  { title: "CORTES", perms: [
    ["crt_pdf","PDF"],
    ["crt_email","eMail"],
    ["crt_excel","Excel"],
    ["crt_editar","Editar"],
    ["crt_salidaProc","Salida a Proceso"],
    ["crt_entradaProc","Entrada de Proceso"],
    ["crt_entradaAlm","Entrada a Almacén"],
    ["crt_habilitacion","Status Habilitación"],
    ["crt_cancelarSal","Cancelar Salida"],
    // L24 (2026-06) — controla si puede contestar "Sí" en el prompt "¿Mostrar precios en el PDF?"
    ["crt_pdfPrecios","Ver Precios en PDF Salida"],
  ]},
  // ===== 5. MUESTRAS (2026-07) =====
  { title: "MUESTRAS", perms: [
    ["menu_muestras","Menú Acceso"],
    ["muestras_create","Crear / Editar"],
  ] },
  { title: "ÓRDENES DE CORTE", perms: [
    ["ocp_pdf","PDF"],
    ["ocp_email","eMail"],
    ["ocp_excel","Excel"],
    ["ocp_editar","Editar"],
    ["ocp_baja","Baja"],
    ["ocp_observaciones","Observaciones"],
    ["ocp_recibir","Recibir"],
    ["ocp_cortar","Cortar / No Cortar"],
    ["ocp_autMolde","Aut. Molde"],
    ["ocp_autorizar","Autorizar Orden"],
    ["ocp_pdfNumInt","PDF Núm. Interno"],
  ]},
  // Mismo título visible que la sección de COMPRAS pero ID interno distinto
  // (en producción "Orden de Compra" se refiere a la orden de corte externo a maquilero).
  { title: "ÓRDENES DE COMPRA (Producción)", displayTitle: "ÓRDENES DE COMPRA", perms: [
    ["ocx_pdf","PDF"],
    ["ocx_email","eMail"],
    ["ocx_excel","Excel"],
    ["ocx_editar","Editar"],
    ["ocx_baja","Baja"],
    ["ocx_observaciones","Observaciones"],
    ["ocx_recibir","Recibir"],
    ["ocx_cortar","Cortar / No Cortar"],
    ["ocx_habilitacion","Habilitación"],
  ]},

  // ===== 5. INVENTARIOS =====
  { title: "INVENTARIOS TELAS", perms: [
    ["menu_inventariosTelas","Menú Acceso"],
    ["inventariosTelas","Ver Inv Telas"],
    ["menu_disponibleTelas","Menú Disponible Telas"],
    ["disponible_vendedores","Disponible Vendedores"],
    ["ivt_pdf","PDF"],
    ["ivt_email","eMail"],
    ["ivt_excel","Excel"],
    ["ivt_editar","Editar"],
    ["ivt_cortarRollo","Cortar Rollo"],
    ["ivt_qr","QR"],
  ]},
  { title: "INVENTARIOS GENERAL", perms: [
    ["menu_inventarios","Menú Acceso"],
    ["inventarios","Ver Inventarios"],
    ["inv_pdf","PDF"],
    ["inv_email","eMail"],
    ["inv_excel","Excel"],
    ["inv_ajuste","Ajuste"],
  ]},
  { title: "SEGUIMIENTO TELAS", perms: [
    ["seg_pdf","PDF"],
    ["seg_email","eMail"],
    ["seg_excel","Excel"],
  ]},
  { title: "INV. HABILITACIÓN", perms: [
    ["ivh_pdf","PDF"],
    ["ivh_email","eMail"],
    ["ivh_excel","Excel"],
    ["ivh_salida","Salida"],
  ]},
  { title: "TRASPASOS SALIDA", perms: [
    ["menu_traspasos_salida","Menú Acceso"],
    ["traspasos_salida_create","Crear"],
    ["tss_pdf","PDF"],
    ["tss_email","eMail"],
    ["tss_excel","Excel"],
    ["tss_editar","Editar"],
  ]},
  { title: "TRASPASOS ENTRADA", perms: [
    ["menu_traspasos_entrada","Menú Acceso"],
    ["traspasos_entrada_create","Crear"],
    ["tse_pdf","PDF"],
    ["tse_email","eMail"],
    ["tse_excel","Excel"],
    ["tse_editar","Editar"],
  ]},
  { title: "AJUSTE", perms: [
    ["aju_pdf","PDF"],
    ["aju_email","eMail"],
    ["aju_excel","Excel"],
    ["aju_editar","Editar"],
  ]},

  // ===== 6. ADMIN / CXC =====
  { title: "ADMIN (Menú)", perms: [["menu_admin","Menú Acceso"]] },
  { title: "ABONOS CXC", perms: [
    ["abo_pdf","PDF"],["abo_email","eMail"],
    ["abo_excel","Excel"],["abo_editar","Editar"],["abo_baja","Baja"],
  ]},
  { title: "VENTAS ADMIN", perms: [
    ["vad_pdf","PDF"],["vad_email","eMail"],
    ["vad_excel","Excel"],["vad_editar","Editar"],["vad_cancelar","Cancelar"],
  ]},
  { title: "NOTAS CARGO", perms: [
    ["nca_pdf","PDF"],["nca_email","eMail"],
    ["nca_excel","Excel"],["nca_editar","Editar"],["nca_baja","Baja"],
  ]},
  { title: "DEV ADMIN", perms: [
    ["dva_pdf","PDF"],["dva_email","eMail"],
    ["dva_excel","Excel"],["dva_editar","Editar"],["dva_baja","Baja"],
  ]},

  // ===== RETIROS =====
  // { title: "RETIROS", perms: [
  //   ["ret_pdf","PDF"],["ret_email","eMail"],
  //   ["ret_excel","Excel"],["ret_editar","Editar"],["ret_baja","Baja"],
  // ]},
  // { title: "COMPRA VENTA", perms: [
  //   ["cvt_pdf","PDF"],["cvt_email","eMail"],
  //   ["cvt_excel","Excel"],["cvt_editar","Editar"],["cvt_baja","Baja"],
  // ]},
  // { title: "POR RETIRAR", perms: [
  //   ["prt_pdf","PDF"],["prt_email","eMail"],
  //   ["prt_excel","Excel"],["prt_editar","Editar"],["prt_baja","Baja"],
  // ]},

  // ===== 7. CXP =====
  { title: "CXP (Menú)", perms: [["menu_adminCxP","Menú Acceso"],["menu_cxpPagos","Pagos y Saldos"]] },
  { title: "ABONOS PROVEEDORES", perms: [
    ["abp_pdf","PDF"],["abp_email","eMail"],
    ["abp_excel","Excel"],["abp_editar","Editar"],["abp_baja","Baja"],
  ]},
  { title: "ABONOS MAQUILEROS", perms: [
    ["abm_pdf","PDF"],["abm_email","eMail"],
    ["abm_excel","Excel"],["abm_editar","Editar"],["abm_baja","Baja"],
  ]},
  { title: "ANTICIPOS PROVEEDORES", perms: [
    ["ant_pdf","PDF"],["ant_email","eMail"],
    ["ant_excel","Excel"],["ant_editar","Editar"],["ant_baja","Baja"],
  ]},
  { title: "NOTAS CXP", perms: [
    ["ncp_pdf","PDF"],["ncp_email","eMail"],
    ["ncp_excel","Excel"],["ncp_editar","Editar"],["ncp_baja","Baja"],
  ]},
  // { title: "DOCUMENTACIÓN", perms: [
  //   ["doc_pdf","PDF"],["doc_email","eMail"],
  //   ["doc_excel","Excel"],["doc_editar","Editar"],["doc_baja","Baja"],
  // ]},

  // ===== 8. GASTOS =====
  { title: "GASTOS (Menú)", perms: [["menu_gastos","Menú Acceso"]] },
  { title: "GASTOS (Permisos)", perms: [
    ["gastos_create","Crear"],
    ["gastos_autorizar","Autorizar"],
  ]},
  // { title: "PRESUPUESTOS", perms: [
  //   ["menu_presupuestos","Menú Acceso"],
  //   ["presupuestos_create","Crear"],
  //   ["presupuestos_autorizar","Autorizar"],
  // ]},
  // { title: "INGRESOS / EGRESOS", perms: [
  //   ["menu_ingresos","Menú Ingresos"],
  //   ["menu_egresos","Menú Egresos"],
  // ]},

  // ===== 9. COLABORADORES =====
  { title: "COLABORADORES (Menú)", perms: [["menu_nominas","Menú Acceso"]] },
  { title: "EMPLEADOS", perms: [
    ["menu_empleados","Menú Acceso"],
    ["empleados_create","Crear"],
    ["empleados_sueldo","Sueldo"],
  ]},
  { title: "COLABORADORES", perms: [
    ["clb_pdf","PDF"],["clb_email","eMail"],
    ["clb_excel","Excel"],["clb_editar","Editar"],["clb_baja","Baja"],
  ]},
  { title: "PUESTOS", perms: [["menu_puestos","Menú Acceso"],["puestos_create","Crear"]] },
  { title: "NÓMINAS (Datos)", perms: [
    ["nominas_create","Crear"],
    ["nominas_listado","Listado"],
    ["nominas_pagos_esp","Pagos Especiales"],
    ["nominas_pagar","Pagar"],
  ]},

  // ===== 10. USUARIOS =====
  { title: "USUARIOS", perms: [
    ["menu_usuarios","Menú Acceso"],
    ["usuarios_create","Crear"],
    ["usuarios_permisos","Asignar Permisos"],
  ]},

  // ===== 11. LOGS =====
  { title: "LOGS", perms: [
    ["menu_logs","Menú Acceso"],
    ["log_pdf","PDF"],
    ["log_email","eMail"],
    ["log_excel","Excel"],
  ]},

  // ===== OTROS MENÚS sueltos =====
  // IMPORTANTE: NO incluimos menu_cobradores ni menu_edoCta_Cliente aquí.
  // Si esos 2 quedan en true el Header oculta el navbar interno y el usuario
  // desaparece del listado /Usuarios. Sólo se manejan vía DB para portal-cliente.
  { title: "OTROS MENÚS", perms: [
    ["menu_catalogos","Menú Catálogos"],
    ["menu_reportes","Menú Reportes"],
    ["menu_empresas","Menú Empresas"],
    // ["menuSocios","Menú Socios"],
    // No usados en Langiani (heredados del template escolar Sistemify) — comentados:
    // ["menu_planteles","Menú Planteles"],          // escolar
    // ["menu_areas","Menú Áreas"],                   // escolar
    // ["menu_ciclos","Menú Ciclos"],                 // escolar
    // ["menu_periodos_admin","Menú Periodos Admin"], // escolar
    // ["menu_departamentos","Menú Departamentos"],   // escolar
  ]},
];

// Claves PROHIBIDAS de mass-toggle: si quedan en true rompen el Header / Listado de Usuarios.
// Aunque LEGACY_PERMS_ALL las contenga, ningún "Activar TODO" / macro / sección las debe tocar.
const DANGEROUS_KEYS = new Set(["menu_cobradores", "menu_edoCta_Cliente"]);
const isSafeToMassToggle = (k) => !DANGEROUS_KEYS.has(k);

const SEC_BY_TITLE = Object.fromEntries(MERGED_SECTIONS.map(s => [s.title, s]));

// ===== ROBUSTEZ: re-derivar LEGACY_PERMS_ALL / ALL_PERMS_ALL desde MERGED =====
// Cualquier llave usada en MERGED_SECTIONS que NO sea granular se considera legacy.
// Sin esto, llaves como menu_logs (que están en MERGED pero no en LEGACY_PERMS_SECTIONS)
// quedaban huérfanas y la hidratación no las cargaba al reabrir el modal.
const _MERGED_ALL_KEYS = MERGED_SECTIONS.flatMap(s => s.perms.map(([k]) => k));
_MERGED_ALL_KEYS.forEach(k => {
  if (!GRAN_PERMS_ALL.includes(k) && !LEGACY_PERMS_ALL.includes(k)) {
    LEGACY_PERMS_ALL.push(k);          // se incluye en hidratación de legacyPerms
    ALL_PERMS_ALL.push(k);             // se incluye en "Activar TODO" global
  }
});

const setManyPerms = (keys, val) => {
  // Las DANGEROUS_KEYS (menu_cobradores, menu_edoCta_Cliente) NUNCA se tocan en mass-toggle.
  keys.filter(isSafeToMassToggle).forEach(k => setPerm(k, val));
};
const toggleAllSection = (title, val) => {
  const keys = (SEC_BY_TITLE[title]?.perms || []).map(([k]) => k);
  setManyPerms(keys, val);
};
const toggleAllMacro = (macro, val) => {
  const keys = macro.sections.flatMap(t => (SEC_BY_TITLE[t]?.perms || []).map(([k]) => k));
  setManyPerms(keys, val);
};
const toggleAllGran = (val) => setManyPerms(ALL_PERMS_ALL, val);
const sectionCount = (title) => {
  const keys = (SEC_BY_TITLE[title]?.perms || []).map(([k]) => k);
  const total = keys.length;
  const on = keys.filter(k => getPerm(k)).length;
  return { on, total };
};

const [menu_planteles, setMenuPlanteles] = useState();
const [menu_areas, setMenuAreas] = useState();
const [menuSocios, setMenuSocios] = useState();
const [menu_ciclos, setMenuCiclos] = useState();

const [menu_fiscal, setMenuFiscal] = useState();
const [facturasFiscal, setFacturasFiscal] = useState();
const [compPagosFiscal, setCompPagosFiscal] = useState();
const [devolucionesFiscal, setDevolucionesFiscal] = useState();
const [notasCreditoFiscal, setNotasCreditoFiscal] = useState();
const [menu_empresas, setMenuEmpresas] = useState();

const [menu_admin, setMenuAdmin] = useState();
const [menu_periodos_admin, setMenuPeriodosAdmin] = useState();
const [menu_departamentos, setMenuDepartamentos] = useState();
const [menu_presupuestos, setMenuPresupuestos] = useState();
const [presupuestos_autorizar, setPresupuestosAutorizar] = useState();
const [presupuestos_create, setPresupuestosCreate] = useState();
const [menu_proveedores, setMenuProveedores] = useState();
const [proveedores_create, setProveedoresCreate] = useState();
const [menu_gastos, setMenuGastos] = useState();
const [gastos_create, setGastosCreate] = useState();
const [gastos_autorizar, setGastosAutorizar] = useState();


const [menu_facturas, setMenuFacturas] = useState();
const [menu_clientes, setMenuClientes] = useState();
const [eliminar_fichas, setEliminarFichas] = useState();
const [clientes_create, setClientesCreate] = useState();
const [clientes_edo_cta, setClientesEdoCta] = useState();
const [facturas_edo_cta, setFacturasEdoCta] = useState();
const [facturas_cargos, setFacturasCargos] = useState();
const [facturas_cargos_create, setFacturasCargosCreate] = useState();
const [facturas_abonos, setFacturasAbonos] = useState();
const [facturas_abonos_create, setFacturasAbonosCreate] = useState();
const [facturas_abonos_edit, setFacturasAbonosEdit] = useState();
const [menu_catalogos, setMenuCatalogos] = useState();

const [menu_nominas, setMenuNominas] = useState();
const [menu_empleados, setMenuEmpleados] = useState();
const [empleados_create, setEmpleadosCreate] = useState();
const [empleados_sueldo, setEmpleadosSueldo] = useState();
const [menu_puestos, setMenuPuestos] = useState();
const [puestos_create, setPuestosCreate] = useState();
const [nominas_create, setNominasCreate] = useState();
const [nominas_listado, setNominasListado] = useState();
const [nominas_pagos_esp, setNominasPagosEsp] = useState();
const [nominas_pagar, setNominasPagar] = useState();

const [menu_reportes, setMenuReportes] = useState();
const [menu_ingresos, setMenuIngresos] = useState();
const [menu_egresos, setMenuEgresos] = useState();

const [menu_usuarios, setMenuUsuarios] = useState();
const [usuarios_create, setUsuariosCreate] = useState();
const [usuarios_permisos, setUsuariosPermisos] = useState();

const [menu_logs, setMenuLogs] = useState();

const [menu_articulos, setMenuArticulos] = useState();
const [menu_colores, setMenuColores] = useState();
const [colores_create, setColoresCreate] = useState();
const [menu_tipos_telas, setMenuTiposTelas] = useState();
const [tipos_telas_create, setTiposTelasCreate] = useState();
const [articulos_create, setArticulosCreate] = useState();
const [menu_inventariosTelas, setMenuInventariosTelas] = useState();
const [inventariosTelas, setInventariosTelas] = useState();
const [menu_inventarios, setMenuInventarios] = useState();
const [inventarios, setInventarios] = useState();
const [menu_compras, setMenuCompras] = useState();
const [menu_oc, setMenuOC] = useState();
const [oc_create, setOCCreate] = useState();
const [oc_autorizacion, setOCAutorizacion] = useState();
const [compras, setCompras] = useState();
const [compras_create, setComprasCreate] = useState();
const [menu_ventas, setMenuVentas] = useState();
const [ventas_create, setVentasCreate] = useState();
const [menu_pedidos, setMenuPedidos] = useState();
const [pedidos_create, setPedidosCreate] = useState();
const [menu_devoluciones, setMenuDevoluciones] = useState();
const [devoluciones_create, setDevolucionesCreate] = useState();
const [menu_disponible, setMenuDisponible] = useState();
const [disponible_vendedores, setDisponibleVendedores] = useState();
const [surtidos_create, setSurtidosCreate] = useState();
const [menu_surtidos, setMenuSurtidos] = useState();


const [menu_devolucionesProveedores, setMenuDevolucionesProveedores] = useState();
const [devolucionesProveedores_create, setDevolucionesProveedoresCreate] = useState();
const [menu_adminCxP, setMenuAdminCxP] = useState();
const [menu_disponibleTelas, setMenuDisponibleTelas] = useState();
const [menu_habilitacion, setMenuHabilitacion] = useState();
const [habilitacion_create, setHabilitacionCreate] = useState();
const [menu_telas, setMenuTelas] = useState();
const [telas_create, setTelasCreate] = useState();
const [menu_produccion, setMenuProduccion] = useState();
const [cancelar_compra, setCancelarCompra] = useState();

const [menu_traspasos_salida, setMenuTraspasosSalida] = useState();
const [traspasos_salida_create, setTraspasosSalidaCreate] = useState();
const [menu_traspasos_entrada, setMenuTraspasosEntrada] = useState();
const [traspasos_entrada_create, setTraspasosEntradaCreate] = useState();

const [emailSis, setEmailSis] = useState("admin@lynqro.com");

const [modal, setModal] = useState(false);
const toggle = () => setModal(!modal);
const [text, setText] = useState(false);

const [modalPermisos, setModalPermisos] = useState(false);
const togglePermisos = () => setModalPermisos(!modalPermisos);

  useEffect(() => {
    axios
      .get(URL_LISTA_USERS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allUsuarios = response.data;
        let arrayTabla = allUsuarios
        .sort((a, b) => (a.apellido > b.apellido ? 1 : -1))
        .map((a) => {
          return {
            // Spread completo: incluye TODOS los campos del usuario (legacy + 249 granulares).
            // Sin esto, al reabrir Permisos los granulares se hidratan a false aunque la DB tenga true.
            ...a,
            _id:a._id,
            nombre: a.nombre,
            apellido: a.apellido,
            email: a.email,
            is_active: a.is_active,
            menu_edoCta_Cliente: a.menu_edoCta_Cliente,
            menu_planteles: a.menu_planteles,
            menu_areas: a.menu_areas,
            menuSocios: a.menuSocios,
            menu_ciclos: a.menu_ciclos,
            menu_admin: a.menu_admin,
            menu_periodos_admin: a.menu_periodos_admin,
            menu_departamentos: a.menu_departamentos,
            menu_presupuestos: a.menu_presupuestos,
            presupuestos_autorizar: a.presupuestos_autorizar,
            presupuestos_create: a.presupuestos_create,
            menu_proveedores: a.menu_proveedores,
            proveedores_create: a.proveedores_create,
            menu_gastos: a.menu_gastos,
            gastos_create: a.gastos_create,
            gastos_autorizar: a.gastos_autorizar,
            menu_facturas: a.menu_facturas,
            menu_clientes: a.menu_clientes,
            clientes_create: a.clientes_create,
            eliminar_fichas: a.eliminar_fichas,
            clientes_edo_cta: a.clientes_edo_cta,
            facturas_edo_cta: a.facturas_edo_cta,
            facturas_cargos: a.facturas_cargos,
            facturas_cargos_create: a.facturas_cargos_create,
            facturas_abonos: a.facturas_abonos,
            facturas_abonos_create: a.facturas_abonos_create,
            menu_catalogos: a.menu_catalogos,
            menu_nominas: a.menu_nominas,
            menu_empleados: a.menu_empleados,
            empleados_create: a.empleados_create,
            empleados_sueldo: a.empleados_sueldo,
            menu_puestos: a.menu_puestos,
            puestos_create: a.puestos_create,
            nominas_create: a.nominas_create,
            nominas_listado: a.nominas_listado,
            nominas_pagos_esp: a.nominas_pagos_esp,
            nominas_pagar: a.nominas_pagar,
            menu_reportes: a.menu_reportes,
            menu_ingresos: a.menu_ingresos,
            menu_egresos: a.menu_egresos,
            menu_usuarios: a.menu_usuarios,
            usuarios_create: a.usuarios_create,
            usuarios_permisos: a.usuarios_permisos,
            facturas_abonos_edit: a.facturas_abonos_edit,
            menu_logs: a.menu_logs,
            menu_cobradores: a.menu_cobradores,
            menu_articulos: a.menu_articulos,
            menu_colores: a.menu_colores,
            colores_create: a.colores_create,
            menu_tipos_telas: a.menu_tipos_telas,
            tipos_telas_create: a.tipos_telas_create,
            articulos_create: a.articulos_create,
            menu_inventariosTelas: a.menu_inventariosTelas,
            inventariosTelas: a.inventariosTelas,
            menu_inventarios: a.menu_inventarios,
            inventarios: a.inventarios,
            menu_compras: a.menu_compras,
            menu_oc: a.menu_oc,
            oc_create: a.oc_create,
            oc_autorizacion: a.oc_autorizacion,
            compras: a.compras,
            compras_create: a.compras_create,
            menu_ventas: a.menu_ventas,
            ventas_create: a.ventas_create,
            menu_pedidos: a.menu_pedidos,
            pedidos_create: a.pedidos_create,
            menu_devoluciones: a.menu_devoluciones,
            devoluciones_create: a.devoluciones_create,
            menu_disponible: a.menu_disponible,
            disponible_vendedores: a.disponible_vendedores,
            menu_surtidos: a.menu_surtidos,
            surtidos_create: a.surtidos_create,
            menu_devolucionesProveedores: a.menu_devolucionesProveedores,
            devolucionesProveedores_create: a.devolucionesProveedores_create,
            menu_adminCxP: a.menu_adminCxP,
            menu_fiscal: a.menu_fiscal,
            facturasFiscal: a.facturasFiscal,
            compPagosFiscal: a.compPagosFiscal,
            devolucionesFiscal: a.devolucionesFiscal,
            notasCreditoFiscal: a.notasCreditoFiscal,
            menu_empresas: a.menu_empresas,
            menu_disponibleTelas: a.menu_disponibleTelas,
            menu_habilitacion: a.menu_habilitacion,
            habilitacion_create: a.habilitacion_create,
            menu_telas: a.menu_telas,
            telas_create: a.telas_create,
            menu_produccion: a.menu_produccion,
            cancelar_compra: a.cancelar_compra,
            menu_traspasos_salida: a.menu_traspasos_salida,
            traspasos_salida_create: a.traspasos_salida_create,
            menu_traspasos_entrada: a.menu_traspasos_entrada,
            traspasos_entrada_create: a.traspasos_entrada_create,
          }
        }).filter(function (el) {
          return el != null;
        });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal)
        setUsuarios(allUsuarios);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_PLANTELES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPlanteles = res.data;
        setPlanteles(allPlanteles);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  },[]);

  const headers = [
    { name: "Activo", field: "is_active", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Apellido", field: "apellido", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
];

  const commentsData = useMemo(() => {
    let computedComments = comments

    if (search) {
        computedComments = computedComments.filter(
            comment =>
                comment.is_active.toLowerCase().includes(search.toLowerCase()) ||
                comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
                comment.apellido.toLowerCase().includes(search.toLowerCase()) ||
                comment.email.toLowerCase().includes(search.toLowerCase())
        );
    }


    if(activo){
      computedComments = computedComments.filter((e)=>
      e.is_active.includes(activo)
      ) 
    } 

    if(emailSis){
      computedComments = computedComments.filter((e)=>
      !e.email.includes(emailSis)
      ) 
    }     

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
        const reversed = sorting.order === "asc" ? 1 : -1;
        computedComments = computedComments.sort(
            (a, b) =>
                reversed * a[sorting.field].localeCompare(b[sorting.field])
        );
    }

    //Current Page slice
    return computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
}, [comments, currentPage, search, sorting, activo, email]);

function Edit(idEdit, nombre, apellido, email){
  axios
  .get(`${URL_USERS}/${idEdit}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  }).then((response)=>{
    let usuarioEdit = response.data;
    setPlantel(usuarioEdit.planteles[0]._id)
    setArea(usuarioEdit.areas[0]._id)
  })
  setIdEdit(idEdit)
  setNombre(nombre)
  setApellido(apellido)
  setEmail(email)
  toggle()
}

function editUsuario(event) {
  event.preventDefault();
  axios
    .patch(
      `${URL_USERS}/${idEdit}`,
      {
        nombre,
        apellido,
        email,
        planteles: plantel,
        areas: area,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      toggle();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
     .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

function Permisos (
  id, 
  nombre,
  apellido,
  menu_planteles,
  menu_areas,
  menuSocios,
  menu_ciclos,
  menu_admin,
  menu_periodos_admin,
  menu_departamentos,
  menu_presupuestos,
  presupuestos_autorizar,
  presupuestos_create,
  menu_proveedores,
  proveedores_create,
  menu_gastos,
  gastos_create,
  gastos_autorizar,
  menu_facturas,
  menu_clientes,
  clientes_create,
  eliminar_fichas,
  clientes_edo_cta,
  facturas_edo_cta,
  facturas_cargos,
  facturas_cargos_create,
  facturas_abonos,
  facturas_abonos_create,
  menu_catalogos,
  menu_nominas,
  menu_empleados,
  empleados_create,
  empleados_sueldo,
  menu_puestos,
  puestos_create,
  nominas_create,
  nominas_listado,
  nominas_pagos_esp,
  nominas_pagar,
  menu_reportes,
  menu_ingresos,
  menu_egresos,
  menu_usuarios,
  usuarios_create,
  usuarios_permisos,
  facturas_abonos_edit,
  menu_logs,
  menu_articulos,
  menu_colores,
  colores_create,
  menu_tipos_telas,
  tipos_telas_create,
  articulos_create,
  menu_inventariosTelas,
  inventariosTelas,
  menu_inventarios,
  inventarios,
  menu_compras,
  menu_oc,
  oc_create,
  oc_autorizacion,
  compras,
  compras_create,
  menu_ventas,
  ventas_create,
  menu_pedidos,
  pedidos_create,
  menu_devoluciones,
  devoluciones_create,
  menu_disponible,
  disponible_vendedores,
  menu_surtidos,
  surtidos_create,
  menu_devolucionesProveedores,
  devolucionesProveedores_create,
  menu_adminCxP,
  menu_fiscal,
  facturasFiscal,
  compPagosFiscal,
  devolucionesFiscal,
  notasCreditoFiscal,
  menu_empresas,
  menu_disponibleTelas,
  menu_habilitacion,
  habilitacion_create,
  menu_telas,
  telas_create,
  menu_produccion,
  cancelar_compra,
  menu_traspasos_salida,
  traspasos_salida_create,
  menu_traspasos_entrada,
  traspasos_entrada_create,
  pFull, // <-- objeto completo del usuario para permisos granulares
  ){
        // Hidrata granPerms desde el usuario
        const nextGran = emptyGranPerms();
        if (pFull) GRAN_PERMS_ALL.forEach(k => { nextGran[k] = !!pFull[k]; });
        setGranPerms(nextGran);
        // Hidrata legacyPerms desde el usuario
        const nextLegacy = emptyLegacyPerms();
        if (pFull) LEGACY_PERMS_ALL.forEach(k => { nextLegacy[k] = !!pFull[k]; });
        setLegacyPerms(nextLegacy);
        setIdPermisos(id)
        setNombre(nombre)
        setApellido(apellido)
        setMenuAdmin(menu_admin)
        setMenuFacturas(menu_facturas)
        setMenuNominas(menu_nominas)
        setMenuReportes(menu_reportes)
        setMenuUsuarios(menu_usuarios)
        setMenuPlanteles(menu_planteles)
        setMenuAreas(menu_areas)
        setMenuSocios(menuSocios)
        setMenuCiclos(menu_ciclos)
        setMenuPeriodosAdmin(menu_periodos_admin)
        setMenuDepartamentos(menu_departamentos)
        setMenuPresupuestos(menu_presupuestos)
        setPresupuestosAutorizar(presupuestos_autorizar)
        setPresupuestosCreate(presupuestos_create)
        setMenuProveedores(menu_proveedores)
        setMenuGastos(menu_gastos)
        setMenuClientes(menu_clientes)
        setMenuCatalogos(menu_catalogos)
        setMenuEmpleados(menu_empleados)
        setMenuPuestos(menu_puestos)
        setMenuIngresos(menu_ingresos)
        setMenuEgresos(menu_egresos)
        setNominasCreate(nominas_create)
        setProveedoresCreate(proveedores_create)
        setGastosCreate(gastos_create)
        setGastosAutorizar(gastos_autorizar)
        setClientesCreate(clientes_create)
        setEliminarFichas(eliminar_fichas)
        setClientesEdoCta(clientes_edo_cta)
        setFacturasEdoCta(facturas_edo_cta)
        setFacturasCargos(facturas_cargos)
        setFacturasCargosCreate(facturas_cargos_create)
        setFacturasAbonos(facturas_abonos)
        setFacturasAbonosCreate(facturas_abonos_create)
        setEmpleadosCreate(empleados_create)
        setEmpleadosSueldo(empleados_sueldo)
        setPuestosCreate(puestos_create)
        setNominasListado(nominas_listado)
        setNominasPagosEsp(nominas_pagos_esp)
        setNominasPagar(nominas_pagar)
        setUsuariosCreate(usuarios_create)
        setUsuariosPermisos(usuarios_permisos)
        setFacturasAbonosEdit(facturas_abonos_edit)
        setMenuLogs(menu_logs)
        setMenuArticulos(menu_articulos)
        setMenuColores(menu_colores)
        setColoresCreate(colores_create)
        setMenuTiposTelas(menu_tipos_telas)
        setTiposTelasCreate(tipos_telas_create)
        setArticulosCreate(articulos_create)
        setMenuInventariosTelas(menu_inventariosTelas)
        setInventariosTelas(inventariosTelas)
        setMenuInventarios(menu_inventarios)
        setInventarios(inventarios)
        setMenuCompras(menu_compras)
        setMenuOC(menu_oc)
        setOCCreate(oc_create)
        setOCAutorizacion(oc_autorizacion)
        setCompras(compras)
        setComprasCreate(compras_create)
        setMenuVentas(menu_ventas)
        setVentasCreate(ventas_create)
        setMenuPedidos(menu_pedidos)
        setPedidosCreate(pedidos_create)
        setMenuDevoluciones(menu_devoluciones)
        setDevolucionesCreate(devoluciones_create)
        setMenuDisponible(menu_disponible)
        setDisponibleVendedores(disponible_vendedores)
        setMenuSurtidos(menu_surtidos)
        setSurtidosCreate(surtidos_create)
        setMenuDevolucionesProveedores(menu_devolucionesProveedores)
        setDevolucionesProveedoresCreate(devolucionesProveedores_create)
        setMenuAdminCxP(menu_adminCxP)
        setMenuFiscal(menu_fiscal)
        setFacturasFiscal(facturasFiscal)
        setCompPagosFiscal(compPagosFiscal)
        setDevolucionesFiscal(devolucionesFiscal)
        setNotasCreditoFiscal(notasCreditoFiscal)
        setMenuEmpresas(menu_empresas)
        setMenuDisponibleTelas(menu_disponibleTelas)
        setMenuHabilitacion(menu_habilitacion)
        setHabilitacionCreate(habilitacion_create)
        setMenuTelas(menu_telas)
        setTelasCreate(telas_create)
        setMenuProduccion(menu_produccion)
        setCancelarCompra(cancelar_compra)
        setMenuTraspasosSalida(menu_traspasos_salida)
        setTraspasosSalidaCreate(traspasos_salida_create)
        setMenuTraspasosEntrada(menu_traspasos_entrada)
        setTraspasosEntradaCreate(traspasos_entrada_create)

        togglePermisos()
}

function permisosUsuario(event) {
  event.preventDefault();
  axios
    .patch(
      `${URL_USERS}/${idPermisos}`,
      {
        menu_planteles,
        menu_areas,
        menuSocios,
        menu_ciclos,
        menu_admin,
        menu_periodos_admin,
        menu_departamentos,
        menu_presupuestos,
        presupuestos_autorizar,
        presupuestos_create,
        menu_proveedores,
        proveedores_create,
        menu_gastos,
        gastos_create,
        gastos_autorizar,
        menu_facturas,
        menu_clientes,
        clientes_create,
        eliminar_fichas,
        clientes_edo_cta,
        facturas_edo_cta,
        facturas_cargos,
        facturas_cargos_create,
        facturas_abonos,
        facturas_abonos_create,
        menu_catalogos,
        menu_nominas,
        menu_empleados,
        empleados_create,
        empleados_sueldo,
        menu_puestos,
        puestos_create,
        nominas_create,
        nominas_listado,
        nominas_pagos_esp,
        nominas_pagar,
        menu_reportes,
        menu_ingresos,
        menu_egresos,
        menu_usuarios,
        usuarios_create,
        usuarios_permisos,
        facturas_abonos_edit,
        menu_logs,
        menu_articulos,
        menu_colores,
        colores_create,
        menu_tipos_telas,
        tipos_telas_create,
        articulos_create,
        menu_inventariosTelas,
        inventariosTelas,
        menu_inventarios,
        inventarios,
        menu_compras,
        menu_oc,
        oc_create,
        oc_autorizacion,
        compras,
        compras_create,
        menu_ventas,
        ventas_create,
        menu_pedidos,
        pedidos_create,
        menu_devoluciones,
        devoluciones_create,
        menu_disponible,
        disponible_vendedores,
        menu_surtidos,
        surtidos_create,
        menu_devolucionesProveedores,
        devolucionesProveedores_create,
        menu_adminCxP,
        menu_fiscal,
        facturasFiscal,
        devolucionesFiscal,
        notasCreditoFiscal,
        compPagosFiscal,
        menu_empresas,
        menu_disponibleTelas,
        menu_habilitacion,
        habilitacion_create,
        menu_telas,
        telas_create,
        menu_produccion,
        cancelar_compra,
        menu_traspasos_salida,
        traspasos_salida_create,
        menu_traspasos_entrada,
        traspasos_entrada_create,
        eliminar_fichas,
        ...legacyPerms, // <-- todos los menu_* y *_create (sobrescribe los useState)
        ...granPerms,   // <-- todos los 249 permisos granulares
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      togglePermisos();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
     .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

  return (
    <>
    <Header />
    <br />
    {user.menu_usuarios  ?(
        <div className="row">
        {
          <div className="col-12">
            <div className="card container">
              <div className="card-body">
                <h3 align="center">Usuarios</h3>
                <div className="row">
                        <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        <div className="col-md-6 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
            <Table size="sm" striped borderless className="table-responsive-xl">
                <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
                    <tbody>
                    {commentsData
                    .map((p) => {
                        // if (p.menu_edoCta_Fam == false && p.menu_edoCta_Cliente == false && p.email != "admin@lynqro.com") {
                      return (
                        <tr>
                          <td>{p.is_active}</td>
                          <td>{p.nombre}</td>
                          <td>{p.apellido}</td>
                          <td>{p.email}</td>
                          <td>
                          {user.usuarios_create?(
                          <Button color="info" id="Editar" size="sm" onClick={e=>{Edit(p._id, p.nombre, p.apellido, p.email)}}>
                            <i class="far fa-edit"></i>
                          </Button>
                        ):(
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="far fa-edit"></i>
                          </Button>
                        )}
                            {user.usuarios_permisos  && user.is_active =="Si" ?(
                            <Button color="success" id="Permisos" size="sm" onClick={e=>{Permisos(
                              p._id, 
                              p.nombre,
                              p.apellido,
                              p.menu_planteles,
                              p.menu_areas,
                              p.menuSocios,
                              p.menu_ciclos,
                              p.menu_admin,
                              p.menu_periodos_admin,
                              p.menu_departamentos,
                              p.menu_presupuestos,
                              p.presupuestos_autorizar,
                              p.presupuestos_create,
                              p.menu_proveedores,
                              p.proveedores_create,
                              p.menu_gastos,
                              p.gastos_create,
                              p.gastos_autorizar,
                              p.menu_facturas,
                              p.menu_clientes,
                              p.clientes_create,
                              p.eliminar_fichas,
                              p.clientes_edo_cta,
                              p.facturas_edo_cta,
                              p.facturas_cargos,
                              p.facturas_cargos_create,
                              p.facturas_abonos,
                              p.facturas_abonos_create,
                              p.menu_catalogos,
                              p.menu_nominas,
                              p.menu_empleados,
                              p.empleados_create,
                              p.empleados_sueldo,
                              p.menu_puestos,
                              p.puestos_create,
                              p.nominas_create,
                              p.nominas_listado,
                              p.nominas_pagos_esp,
                              p.nominas_pagar,
                              p.menu_reportes,
                              p.menu_ingresos,
                              p.menu_egresos,
                              p.menu_usuarios,
                              p.usuarios_create,
                              p.usuarios_permisos,
                              p.facturas_abonos_edit,
                              p.menu_logs,
                              p.menu_articulos,
                              p.menu_colores,
                              p.colores_create,
                              p.menu_tipos_telas,
                              p.tipos_telas_create,
                              p.articulos_create,
                              p.menu_inventariosTelas,
                              p.inventariosTelas,
                              p.menu_inventarios,
                              p.inventarios,
                              p.menu_compras,
                              p.menu_oc,
                              p.oc_create,
                              p.oc_autorizacion,
                              p.compras,
                              p.compras_create,
                              p.menu_ventas,
                              p.ventas_create,
                              p.menu_pedidos,
                              p.pedidos_create,
                              p.menu_devoluciones,
                              p.devoluciones_create,
                              p.menu_disponible,
                              p.disponible_vendedores,
                              p.menu_surtidos,
                              p.surtidos_create,
                              p.menu_devolucionesProveedores,
                              p.devolucionesProveedores_create,
                              p.menu_adminCxP,
                              p.menu_fiscal,
                              p.facturasFiscal,
                              p.compPagosFiscal,
                              p.devolucionesFiscal,
                              p.notasCreditoFiscal,
                              p.menu_empresas,
                              p.menu_disponibleTelas,
                              p.menu_habilitacion,
                              p.habilitacion_create,
                              p.menu_telas,
                              p.telas_create,
                              p.menu_produccion,
                              p.cancelar_compra,
                              p.menu_traspasos_salida,
                              p.traspasos_salida_create,
                              p.menu_traspasos_entrada,
                              p.traspasos_entrada_create,
                              p, // <-- objeto completo para permisos granulares
                              )}}>
                            <i class="fas fa-key"></i>{" "}
                          </Button>
                            ):(
                              <Button color="success" id="Permisos" size="sm" disabled>
                            <i class="fas fa-key"></i>{" "}
                          </Button>
                            )}
                            {user.usuarios_create?(
                          <Baja
                            idStatus={p._id}
                            is_active={p.is_active}
                            URL_BAJA={process.env.REACT_APP_URL_USERS}
                          />
                            ):undefined}
                          </td>
                        </tr>
                      );
                      // }
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        }
        {/* <div className="col-4">
          <div className="card">
            <div className="card-body">
              <Signup />
            </div>
          </div>
        </div> */}
        </div>
      ): undefined } 

<Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}><h4>Editar Usuario {nombre} {apellido} </h4></ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={nombre}
            required
            onChange={(e) => {
              setNombre(e.target.value);
            }}
          />
          <Label className="mr-sm-2">Apellido</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={apellido}
            required
            onChange={(e) => {
              setApellido(e.target.value);
            }}
          />
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={email}
            required
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          {/* <Label>Plantel</Label>
              <Input
                type="select"
                value={plantel}
                required
                onChange={(e) => {
                  setPlantel(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {planteles.map((a) => {
                  return <option value={a._id}>{a.name}</option>;
                })}
              </Input>
              <Label className="mr-sm-2">Areas</Label>
                <Input
                  type="select"
                  value={area}
                  required
                  onChange={(e) => setArea(e.target.value)}
                >
                  <option value="0">Selecciona</option>
                  {areas
                    .sort((a, b) => a.name - b.name)
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input> */}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editUsuario}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* //Permisos */}
      <Modal size="xl" isOpen={modalPermisos} toggle={togglePermisos}>
        <ModalHeader toggle={togglePermisos}><h4>Permisos de {nombre} {apellido} </h4></ModalHeader>
        <ModalBody>
        <div className="container">
        <br/>
        {/* === OCULTO: render hand-coded legacy (sustituido por sectionado unificado abajo) === */}
        {false && (<><Row>

      <Col md={3}>
    <h5>CATALOGOS</h5> <Input
        type="checkbox"
        onChange={(event) => setMenuColores(event.currentTarget.checked)}
        checked={menu_colores}
      /><h5 className="subMenuTitulo">Menu Colores</h5>
      <Input
        type="checkbox"
        onChange={(event) => setColoresCreate(event.currentTarget.checked)}
        checked={colores_create}
      /><h5 className="subMenuTitulo">Crear Colores</h5>

      <Input
        type="checkbox"
        onChange={(event) => setMenuTiposTelas(event.currentTarget.checked)}
        checked={menu_tipos_telas}
      /><h5 className="subMenuTitulo">Menu Tipos de Tela</h5>
      <Input
        type="checkbox"
        onChange={(event) => setTiposTelasCreate(event.currentTarget.checked)}
        checked={tipos_telas_create}
      /><h5 className="subMenuTitulo">Crear Tipos de Tela</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuTelas(event.currentTarget.checked)}
        checked={menu_telas}
      /><h5 className="subMenuTitulo">Telas</h5>
      <Input
        type="checkbox"
        onChange={(event) => setMenuHabilitacion(event.currentTarget.checked)}
        checked={menu_habilitacion}
      /><h5 className="subMenuTitulo">Habilitacion</h5>
     
     <Input
        type="checkbox"
        onChange={(event) => setMenuInventariosTelas(event.currentTarget.checked)}
        checked={menu_inventariosTelas}
      /><h5 className="subMenuTitulo">Inventario Materiales</h5>

     

    {/* <h5>ARTICULOS</h5> */}
        <Input
        type="checkbox"
        onChange={(event) => setMenuArticulos(event.currentTarget.checked)}
        checked={menu_articulos}
      /><h5 className="subMenuTitulo">Articulos</h5>
        <Input
        type="checkbox"
        onChange={(event) => setArticulosCreate(event.currentTarget.checked)}
        checked={articulos_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Articulos</h5>
     <Input
        type="checkbox"
        onChange={(event) => setMenuClientes(event.currentTarget.checked)}
        checked={menu_clientes}
        className="subMenu"
      /><h5 className="subMenuTitulo">Clientes</h5>
      <Input
        type="checkbox"
        onChange={(event) => setClientesCreate(event.currentTarget.checked)}
        checked={clientes_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Clientes</h5>
     <Input
        type="checkbox"
        onChange={(event) => setEliminarFichas(event.currentTarget.checked)}
        checked={eliminar_fichas}
        className="subMenu"
      /><h5 className="subMenuTitulo">Eliminar Fichas Técnicas</h5>


     <Input
        type="checkbox"
        onChange={(event) => setMenuProveedores(event.currentTarget.checked)}
        checked={menu_proveedores}
        className="subMenu"
      /><h5 className="subMenuTitulo">Proveedores</h5>
      <Input
        type="checkbox"
        onChange={(event) => setProveedoresCreate(event.currentTarget.checked)}
        checked={proveedores_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Proveedores</h5>
      </Col>

      <Col md={3}>
      <h5>COMPRAS</h5>
      
       <Input
        type="checkbox"
        onChange={(event) => setMenuCompras(event.currentTarget.checked)}
        checked={menu_compras}
        className="subMenu"
      /><h5 className="subMenuTitulo">Compras</h5>
      <Input
        type="checkbox"
        onChange={(event) => setComprasCreate(event.currentTarget.checked)}
        checked={compras_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Compras</h5>
      <Input
        type="checkbox"
        onChange={(event) => setCancelarCompra(event.currentTarget.checked)}
        checked={cancelar_compra}
        className="subMenu"
      /><h5 className="subMenuTitulo">Cancelar Compra</h5>
      <Input
        type="checkbox"
        onChange={(event) => setMenuOC(event.currentTarget.checked)}
        checked={menu_oc}
        className="subMenu"
      /><h5 className="subMenuTitulo">Ordenes de Compra</h5>
      <Input
        type="checkbox"
        onChange={(event) => setOCCreate(event.currentTarget.checked)}
        checked={oc_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Ordenes de Compra</h5>
      <Input
        type="checkbox"
        onChange={(event) => setOCAutorizacion(event.currentTarget.checked)}
        checked={oc_autorizacion}
        className="subMenu"
      /><h5 className="subMenuTitulo">Autorizar Ordenes de Compra</h5>

    <Input
        type="checkbox"
        onChange={(event) => setMenuDevolucionesProveedores(event.currentTarget.checked)}
        checked={menu_devolucionesProveedores}
        className="subMenu"
      /><h5 className="subMenuTitulo">Devoluciones a Proveedores</h5>
          <Input
        type="checkbox"
        onChange={(event) => setDevolucionesProveedoresCreate(event.currentTarget.checked)}
        checked={devolucionesProveedores_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Devoluciones a Proveedores</h5>
      </Col>

      <Col>
      <h5>PRODUCCION</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuProduccion(event.currentTarget.checked)}
        checked={menu_produccion}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Produccion</h5>

      <br/>
      
      <h5>ADMIN CXP</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuAdminCxP(event.currentTarget.checked)}
        checked={menu_adminCxP}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Admin CXP</h5>
      </Col>

      <Col md={3}>
      <h5>VENTAS</h5>
      <Input
        type="checkbox"
        onChange={(event) => setMenuVentas(event.currentTarget.checked)}
        checked={menu_ventas}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Ventas</h5>
       <Input
        type="checkbox"
        onChange={(event) => setVentasCreate(event.currentTarget.checked)}
        checked={ventas_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Ventas</h5>
      
       <Input
        type="checkbox"
        onChange={(event) => setMenuPedidos(event.currentTarget.checked)}
        checked={menu_pedidos}
        className="subMenu"
      /><h5 className="subMenuTitulo">Pedidos</h5>
      <Input
        type="checkbox"
        onChange={(event) => setPedidosCreate(event.currentTarget.checked)}
        checked={pedidos_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Pedidos</h5>
       <Input
        type="checkbox"
        onChange={(event) => setMenuSurtidos(event.currentTarget.checked)}
        checked={menu_surtidos}
        className="subMenu"
      /><h5 className="subMenuTitulo">Surtidos</h5>
       <Input
        type="checkbox"
        onChange={(event) => setSurtidosCreate(event.currentTarget.checked)}
        checked={surtidos_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Surtidos</h5>
      <Input
        type="checkbox"
        onChange={(event) => setMenuDevoluciones(event.currentTarget.checked)}
        checked={menu_devoluciones}
        className="subMenu"
      /><h5 className="subMenuTitulo">Devoluciones</h5>
      <Input
        type="checkbox"
        onChange={(event) => setDevolucionesCreate(event.currentTarget.checked)}
        checked={devoluciones_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Devoluciones</h5>

      </Col>

      </Row>
      <br/>

      <Row>

      <Col md={3}>
      <h5>INVENTARIO</h5>
      <Input
        type="checkbox"
        onChange={(event) => setMenuInventarios(event.currentTarget.checked)}
        checked={menu_inventarios}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Inventarios</h5>
      <Input
        type="checkbox"
        onChange={(event) => setInventarios(event.currentTarget.checked)}
        checked={inventarios}
        className="subMenu"
      /><h5 className="subMenuTitulo">Inventarios</h5>
       <Input
        type="checkbox"
        onChange={(event) => setMenuDisponible(event.currentTarget.checked)}
        checked={menu_disponible}
        className="subMenu"
      /><h5 className="subMenuTitulo">Disponible</h5>
      <Input
        type="checkbox"
        onChange={(event) => setDisponibleVendedores(event.currentTarget.checked)}
        checked={disponible_vendedores}
        className="subMenu"
      /><h5 className="subMenuTitulo">Disponible Vendedores</h5>

      <Input
        type="checkbox"
        onChange={(event) => setMenuTraspasosSalida(event.currentTarget.checked)}
        checked={menu_traspasos_salida}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Traspasos Salida</h5>
      <Input
        type="checkbox"
        onChange={(event) => setTraspasosSalidaCreate(event.currentTarget.checked)}
        checked={traspasos_salida_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Traspasos Salida</h5>
      <Input
        type="checkbox"
        onChange={(event) => setMenuTraspasosEntrada(event.currentTarget.checked)}
        checked={menu_traspasos_entrada}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Traspasos Entrada</h5>
      <Input
        type="checkbox"
        onChange={(event) => setTraspasosEntradaCreate(event.currentTarget.checked)}
        checked={traspasos_entrada_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Traspasos Entrada</h5>
          
      </Col>

      <Col md={3}>
    <h5>EMPLEADOS</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuNominas(event.currentTarget.checked)}
        checked={menu_nominas}
      /><h5 className="subMenuTitulo">Menu Empleados</h5>
      
      <Input
        type="checkbox"
        onChange={(event) => setMenuEmpleados(event.currentTarget.checked)}
        checked={menu_empleados}
        className="subMenu"
      /><h5 className="subMenuTitulo">Empleados</h5>
      <Input
        type="checkbox"
        onChange={(event) => setEmpleadosCreate(event.currentTarget.checked)}
        checked={empleados_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Empleados</h5>
      {/* <Input
        type="checkbox"
        onChange={(event) => setEmpleadosSueldo(event.currentTarget.checked)}
        checked={empleados_sueldo}
        className="subMenu"
      /><h5 className="subMenuTitulo">Sueldo Empleados</h5> */}
      <Input
        type="checkbox"
        onChange={(event) => setMenuPuestos(event.currentTarget.checked)}
        checked={menu_puestos}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Puestos</h5>
      <Input
        type="checkbox"
        onChange={(event) => setPuestosCreate(event.currentTarget.checked)}
        checked={puestos_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Puestos</h5>
      </Col>



      <Col md={3}>
    <h5>REPORTES</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuReportes(event.currentTarget.checked)}
        checked={menu_reportes}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Reportes</h5>
      {/* <Input
        type="checkbox"
        onChange={(event) => setMenuIngresos(event.currentTarget.checked)}
        checked={menu_ingresos}
        className="subMenu"
      /><h5 className="subMenuTitulo">Reporte Ingresos</h5> 
       <Input
        type="checkbox"
        onChange={(event) => setMenuEgresos(event.currentTarget.checked)}
        checked={menu_egresos}
      /><h5>Reporte Egresos</h5>  */}

      <h5>USUARIOS</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuUsuarios(event.currentTarget.checked)}
        checked={menu_usuarios}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Usuarios</h5>
      <Input
        type="checkbox"
        onChange={(event) => setUsuariosCreate(event.currentTarget.checked)}
        checked={usuarios_create}
        className="subMenu"
      /><h5 className="subMenuTitulo">Crear Usuarios</h5>
      <Input
        type="checkbox"
        onChange={(event) => setUsuariosPermisos(event.currentTarget.checked)}
        checked={usuarios_permisos}
        className="subMenu"
      /><h5 className="subMenuTitulo">Permisos Usuarios</h5>
       <br />
      <br />
      </Col>
      <Col>
      <h5>ADMIN</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuAdmin(event.currentTarget.checked)}
        checked={menu_admin}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Admin</h5>
      <Input
      type="checkbox"
      onChange={(event) => setMenuGastos(event.currentTarget.checked)}
      checked={menu_gastos}
      className="subMenu"
    /><h5 className="subMenuTitulo">Menu Gastos</h5>
      <br />
      <br />
      <h5>LOGS</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuLogs(event.currentTarget.checked)}
        checked={menu_logs}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Logs</h5>
      </Col>
      </Row></>)}
      {/* === FIN bloque oculto legacy === */}

      <br/>

      {/* <Row>
      <Col md={3}>
        <h5>FISCAL</h5>
        <Input
        type="checkbox"
        onChange={(event) => setMenuFiscal(event.currentTarget.checked)}
        checked={menu_fiscal}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Fiscal</h5>
       <Input
        type="checkbox"
        onChange={(event) => setMenuEmpresas(event.currentTarget.checked)}
        checked={menu_empresas}
        className="subMenu"
      /><h5 className="subMenuTitulo">Empresas</h5>
      <Input
      type="checkbox"
      onChange={(event) => setFacturasFiscal(event.currentTarget.checked)}
      checked={facturasFiscal}
      className="subMenu"
    /><h5 className="subMenuTitulo">Facturas</h5>  
    <Input
        type="checkbox"
        onChange={(event) => setDevolucionesFiscal(event.currentTarget.checked)}
        checked={devolucionesFiscal}
        className="subMenu"
      /><h5 className="subMenuTitulo">Devoluciones</h5>
      <Input
      type="checkbox"
      onChange={(event) => setNotasCreditoFiscal(event.currentTarget.checked)}
      checked={notasCreditoFiscal}
      className="subMenu"
    /><h5 className="subMenuTitulo">Notas Credito</h5>
    <Input
    type="checkbox"
    onChange={(event) => setCompPagosFiscal(event.currentTarget.checked)}
    checked={compPagosFiscal}
    className="subMenu"
  /><h5 className="subMenuTitulo">Complementos de Pagos</h5>
        </Col>

        <Col md={3}>
      <h5>SOCIEDADES</h5>
      <Input
        type="checkbox"
        onChange={(event) => setMenuSocios(event.currentTarget.checked)}
        checked={menuSocios}
        className="subMenu"
      /><h5 className="subMenuTitulo">Menu Socios</h5>
      </Col>

      
      </Row> */}

      {/* ===== PERMISOS UNIFICADOS POR SECCIONES (2026-06) ===== */}
      <div style={{
        background: "#212529",
        color: "#fff",
        padding: "10px 16px",
        borderRadius: 6,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 8,
      }}>
        <div>
          <h4 style={{ margin: 0, color: "#fff" }}>
            <i className="fas fa-key" style={{ marginRight: 8 }}></i>
            PERMISOS DEL USUARIO
          </h4>
          <small style={{ color: "#adb5bd" }}>
            Activa lo que el usuario podrá ver/usar. Los marcados como [BOTONES] controlan botones individuales dentro de cada vista.
          </small>
        </div>
        <div>
          <Button size="sm" color="success" onClick={() => toggleAllGran(true)} style={{ marginRight: 6 }}>
            <i className="fas fa-check-double" style={{ marginRight: 4 }}></i> Activar TODO
          </Button>
          <Button size="sm" color="secondary" onClick={() => toggleAllGran(false)}>
            <i className="fas fa-times" style={{ marginRight: 4 }}></i> Limpiar TODO
          </Button>
        </div>
      </div>

      {MACRO_GROUPS.filter(isMacroVisible).map((macro) => {
        const visibleSections = macro.sections.filter(isSectionVisible);
        if (visibleSections.length === 0) return null;
        const macroKeys = visibleSections.flatMap(t => visiblePermsOf(SEC_BY_TITLE[t]).map(([k]) => k));
        const macroOn = macroKeys.filter(k => getPerm(k)).length;
        const macroTotal = macroKeys.length;
        return (
          <div key={macro.label} style={{
            border: `1px solid #dee2e6`,
            borderLeft: `5px solid ${macro.color}`,
            borderRadius: 6,
            marginBottom: 12,
            background: "#fff",
            overflow: "hidden",
          }}>
            {/* Macro header */}
            <div style={{
              background: macro.color,
              color: "#fff",
              padding: "8px 14px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <div style={{ fontWeight: 700, fontSize: 14, letterSpacing: 0.5 }}>
                {macro.label}
                <span style={{
                  marginLeft: 10,
                  background: "rgba(255,255,255,0.25)",
                  padding: "1px 8px",
                  borderRadius: 10,
                  fontSize: 11,
                  fontWeight: 500,
                }}>
                  {macroOn}/{macroTotal}
                </span>
              </div>
              <div>
                <Button size="sm" color="light" onClick={() => toggleAllMacro(macro, true)} style={{ marginRight: 4, fontSize: 11, padding: "2px 8px" }}>
                  ✓ Todos
                </Button>
                <Button size="sm" color="dark" onClick={() => toggleAllMacro(macro, false)} style={{ fontSize: 11, padding: "2px 8px" }}>
                  ✗ Limpiar
                </Button>
              </div>
            </div>
            {/* Sub-sections grid */}
            <div style={{ padding: 10 }}>
              <Row>
                {visibleSections.map((title) => {
                  const sec = SEC_BY_TITLE[title];
                  if (!sec) return null;
                  const visPerms = visiblePermsOf(sec);
                  const total = visPerms.length;
                  const on = visPerms.filter(([k]) => getPerm(k)).length;
                  return (
                    <Col md={6} lg={4} key={title} style={{ marginBottom: 10 }}>
                      <div style={{
                        border: "1px solid #e9ecef",
                        borderRadius: 5,
                        background: "#f8f9fa",
                        padding: 8,
                        height: "100%",
                      }}>
                        <div style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: 6,
                          paddingBottom: 4,
                          borderBottom: `2px solid ${macro.color}`,
                        }}>
                          <strong style={{ fontSize: 12, color: "#212529" }}>{sec.displayTitle || sec.title}</strong>
                          <div>
                            <span style={{
                              fontSize: 10,
                              color: on === total && total > 0 ? "#198754" : "#6c757d",
                              marginRight: 6,
                              fontWeight: 600,
                            }}>
                              {on}/{total}
                            </span>
                            <Button
                              size="sm"
                              color={on === total ? "warning" : "success"}
                              onClick={() => toggleAllSection(title, on !== total)}
                              style={{ fontSize: 10, padding: "1px 6px" }}
                              title={on === total ? "Quitar todos" : "Activar todos"}
                            >
                              {on === total ? "−" : "✓"}
                            </Button>
                          </div>
                        </div>
                        {visPerms.map(([key, label]) => (
                          <label key={key} style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 2,
                            cursor: "pointer",
                            padding: "2px 4px",
                            borderRadius: 3,
                            background: getPerm(key) ? "#d1e7dd" : "transparent",
                          }}>
                            <Input
                              type="checkbox"
                              checked={getPerm(key)}
                              onChange={(e) => setPerm(key, e.currentTarget.checked)}
                              style={{ position: "static", margin: 0, marginRight: 6 }}
                            />
                            <span style={{ fontSize: 12, color: "#212529" }}>{label}</span>
                          </label>
                        ))}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </div>
        );
      })}

      </div>
        </ModalBody>
        <ModalFooter>
          <div className="container">
          <Button color="success"
          onClick={permisosUsuario}
          >
            Guardar
          </Button>
          </div>
        </ModalFooter>
      </Modal>

{loader}
    </>
  );
}

export default ListadoUsuarios;
